import { Component, inject, OnInit, output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AnagraficheService } from 'src/app/core/anagrafiche.service';
import { Classifica } from 'src/app/shared/models/classifica.model';
import { HeaderDeclassificaOperazioniMassive, HeaderDeclassificaOperazioniMassiveForm } from '../models/operazioni-massive.model';

@Component({
  selector: 'app-instestazione-declassifica',
  template: `
    <form [formGroup]="headerForm">
      <div class="advanced-form">
        <div class="grid">

          <div class="col-12 lg:col-6">
            <label class="small-label" for="classificaId">Nuova classifica</label>
            <p-dropdown inputId="classificaId" formControlName="classificaId" [options]="classifiche" placeholder="Seleziona la nuova classifica" optionLabel="nomeClassifica" optionValue="classificaId" [style]="{'width': '420px'}"/>
            <p-checkbox name="vietataDivulgazione" formControlName="vietataDivulgazione" inputId="vietataDivulgazione" label="Vietata divulgazione" [binary]="true" class="divulgazione"></p-checkbox>
          </div>

          <div class="col-12 lg:col-6">
            <label class="small-label" for="dataDeclassifica">Data declassifica</label>
            <p-calendar formControlName="dataDeclassifica" inputId="dataDeclassifica"
              dateFormat="dd/mm/yy" selectionMode="single" [showIcon]="true" [inputStyle]="{'width': '420px'}">
            </p-calendar>
          </div>

          <div class="col-12">
            <label class="small-label" for="nota">Nota per registro</label>
            <textarea pInputTextarea rows="10" cols="80" formControlName="nota" id="nota" class="min-h-80px border-round-md border-400  hover:border-primary-600 hover:shadow-3"></textarea>
         </div>
        </div>
      </div>
    </form>
    `,
  styles: `
  .text-area-dialog { min-height: 40px; width: 100%; }
  .divulgazione { margin-left: 40px;}
  `
})
export class InstestazioneDeclassificaComponent implements OnInit {
  onCompiled = output<HeaderDeclassificaOperazioniMassive | undefined>();

  private readonly fb = inject(FormBuilder);
  private readonly anagraficheService = inject(AnagraficheService);

  public headerForm: FormGroup<HeaderDeclassificaOperazioniMassiveForm>;
  public classifiche: Classifica[] = [];

  constructor() {
    this.headerForm = this.fb.group<HeaderDeclassificaOperazioniMassiveForm>({
      classificaId: new FormControl(null, [Validators.required]),
      dataDeclassifica: new FormControl(null, [Validators.required]),
      nota: new FormControl(''),
      vietataDivulgazione: new FormControl(false)
    });

    this.headerForm.valueChanges.subscribe(d => {

      let value: HeaderDeclassificaOperazioniMassive | undefined = undefined;

      if (this.headerForm.valid) {
        if (this.headerForm.value.classificaId && this.headerForm.value.dataDeclassifica) {

          const classificaSelected = this.classifiche.find(e => e.classificaId == this.headerForm.value.classificaId);

          if (classificaSelected) {
            value = {
              classifica: classificaSelected,
              dataDeclassifica: this.headerForm.value.dataDeclassifica,
              nota: this.headerForm.value.nota,
              vietataDivulgazione: this.headerForm.value.vietataDivulgazione ?? false
            };
          }
        }
      }

      this.onCompiled.emit(value);
    });
  }
  ngOnInit(): void {
    this.anagraficheService.classifiche.getAll().subscribe(c => this.classifiche = c);
  }
}
